import React, { Component } from 'react';
import styles from '../Layout.module.css';
import { Link, Navigate } from "react-router-dom";
import axios from 'axios';
import { BaseUrl } from '../config';
import Logo from '../../assets/images/tugo-logo-light.svg';
import LoginImg from '../../assets/images/login-ico.png';
import DarkLoginImg from '../../assets/images/dark-login-ico.png';


var cartItems = localStorage.getItem("cartItems");
 
if(cartItems === null ||  cartItems.length === undefined ){
    localStorage.setItem("cartItems","[]");
}


class Header extends Component {


    constructor(props) {

        super(props);
        this.state = {
        products:[],
        loading:false,
        tempProducts:[],
        payBool:false,
        accountName:(JSON.parse(localStorage.getItem('authData'))?JSON.parse(localStorage.getItem('authData')).accountName:""),
        cartCount:0,
        cookieAccepted: '',
        settingsList: [],
        };
        //this.getProductCategories();

        // let authData = localStorage.getItem('authData');
        // let accountName = [];
        // if(authData!==null)
        // accountName = JSON.parse(authData).accountName;.

        this.getSettings();

        }

    componentDidMount() {

      var cookieChecked = localStorage.getItem('cookie_accepted');
      if(cookieChecked == '' || cookieChecked === null || cookieChecked == 'null'){
        document.body.classList.add('cookies-on');
      }
     }

       getSettings(){

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }
        

          var siteUrl =  window.location.pathname.split('/').pop();
          let URL = BaseUrl + "settings";
             axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
                let responseData = response.data.data[0];
                if(responseData !==''){
                  this.setState({settingsList: responseData});
                  if(responseData.maintananceMode == 1){
                     localStorage.setItem("sitemaintanance", '1');

                      if(siteUrl === "categories" || siteUrl === "sitemaintanance" || siteUrl === "terms"){
                                
                       }else{
 
                        window.location.href = '/sitemaintanance';
                      }

                  }else{

                      localStorage.setItem("sitemaintanance", '0');

                       if(siteUrl === "sitemaintanance"){
                         window.location.href = '/';
                       }

                  }
               }
             }).catch((err) => {

                if(err.response.status == '401'){

                    if(err.response.data.name ==  'TokenExpiredError'){

                            localStorage.clear();
                            window.location.href='/'; 
                    }
                }
             });
       }

        logout(e) {

            if(localStorage.getItem("sitemaintanance") === 1){
               
               localStorage.clear();
               window.location.href='/sitemaintanance'; 

            }else{
               localStorage.clear();
               window.location.href='/'; 
            }
        }

        cartCount(){
        let cartItems = [];
        cartItems = JSON.parse(localStorage.getItem("cartItems"));
        let QtySum = 0;
        if(cartItems!==null)
        {
            cartItems.map((item)=>{
                if(item.qty>0)
                {
                    QtySum+= item.qty;
                }
                });
        }
        return QtySum;
        //this.setState({cartCount:QtySum});

        }

        cartAmount(){

        let cartItems = [];
        cartItems = JSON.parse(localStorage.getItem("cartItems"));
        var cartTotal = 0;
        if(cartItems!==null)
        {
            cartItems.map((item)=>{
                if(item.qty>0)
                {
                    cartTotal += parseFloat(item.PDP_Price1) * item.qty;
                }
                });
        }
        return cartTotal;

        }

        // cookiePopClose(){

        //     var cookieChecked = localStorage.getItem('cookie_accepted');

        //     if(cookieChecked == '' || cookieChecked === null || cookieChecked == 'null'){

        //         //localStorage.setItem('cookie_accepted', 'Yes');

        //         //this.setState({cookieAccepted : 'Yes'});
        //     }

        // }

      homeRedirection(){

           if(localStorage.getItem("sitemaintanance") === 1){
               window.location.href='/sitemaintanance'; 
            }else{
               window.location.href='/'; 
            }
      }

    checkredirection(){

        const queryParameters = window.location.pathname;
        var siteUrlPage =  window.location.pathname.split('/');
        
        if(siteUrlPage[1] !== 'checkout'){

            localStorage.setItem('minimumOrderAmounterror', 'Yes');
            window.location.href='/checkout/pizza'; 
        }
    }
        
    render(){  
        const queryParameters = window.location.pathname;
        var siteUrlPage =  window.location.pathname.split('/').pop();


        return(
            <>
            {/*this.state.cookieAccepted !== 'Yes' && (
                <div className='cookie-bar'>
                <a className='cookie-close' onClick={this.cookiePopClose.bind(this)}></a>
                <p>By viewing our website, you agree to the use of <a href="https://www.tugo.co.uk/cookies" target={'_blank'}>cookies</a>.</p>
                </div>)*/}
        <header>
            <div className="sm-container">
                
                <div className={styles.headFlx}>
                    <a className={styles.logo} onClick={this.homeRedirection.bind(this)}>
                        <img src={Logo} alt="Tugo" />
                    </a>
                    <p className={styles.headTxt}>
                        Online Ordering Portal
                    </p>
                    <div className={styles.headRight}>
                        
                        <div className={styles.rgtFlx}>
                            {/* Login In Start */}
                            {this.state.accountName && siteUrlPage !=='sitemaintanance' && 
                            <a href={void(0)}  className={styles.acc}>
                                <span className={styles.headLog}>
                                {this.state.accountName} <img className={styles.nrm} src={LoginImg} alt="Log in" />
                                                    <img className={styles.hov} src={DarkLoginImg} alt="Log in" />
                                </span>
                                <div className={styles.logout}>
                                    {/* <span>
                                        My Account
                                    </span> */}
                                    <span>
                                    <a href='/account'>
                                        <i className={`fa fa-shopping-cart ${styles.ico}`}></i>
                                        My Orders
                                    </a>
                                    </span>
                                    <span>
                                    <a href='/myaccount'>
                                        <i className={`fa fa-user ${styles.ico}`}></i>
                                        My Account
                                    </a>
                                    </span>
                                    {localStorage.getItem('specialofferdisplay') === 'Yes' && 
                                     <span><a href='/offerinfo'>
                                        <i className={`fa fa-bullhorn ${styles.ico}`}></i>
                                        Special Offer
                                     </a></span>
                                     }

                                    <span onClick={(e)=>this.logout(e)}>
                                        <i className={`fa fa-sign-out ${styles.ico}`}></i>
                                        Logout
                                    </span>
                                </div>
                            </a>
                            }
                            {!this.state.accountName && siteUrlPage !=='sitemaintanance' && 
                            <Link to="/">
                                <span className={styles.headLog}>
                                Login <img className={styles.nrm} src={LoginImg} alt="Log in" />
                                    <img className={styles.hov} src={DarkLoginImg} alt="Log in" />
                                </span>
                            </Link>
                            }

                            {this.cartCount() > 0 && this.cartAmount() < this.state.settingsList.minimumOrderAmount && siteUrlPage !=='sitemaintanance' &&  <a className={styles.cartIco} onClick={this.checkredirection.bind(this)}>
                               <span className={styles.count}>{this.cartCount()}</span>
                                <i className={`fa fa-shopping-cart ${styles.faIco}`}></i>
                            </a>} 

                             {this.cartCount() > 0 && this.cartAmount() >= this.state.settingsList.minimumOrderAmount && siteUrlPage !=='sitemaintanance' &&   <Link 
                              to='/checkoutpay' className={styles.cartIco}>
                               <span className={styles.count}>{this.cartCount()}</span>
                                <i className={`fa fa-shopping-cart ${styles.faIco}`}></i>
                            </Link>} 

                        </div>
                        
                        {/* Login In End */}
                        <a href="tel:02195367351" className={styles.headLink}><i className="fa fa-phone" aria-hidden="true"/>
                            01295 367 351
                        </a>
                        <a href="mailto:info@tugo.co.uk" className={styles.headLink}><i className="fa fa-envelope" />
                            info@tugo.co.uk
                        </a>
                    </div>
                </div>

            </div>
        </header>
        </>
        );
    }
}
export default Header;